import styled from "@emotion/styled"

const Title = styled.h1`
    text-align: center;
    margin-bottom: 4rem;
`
export default Title
